import cx from 'classnames';

import {Button, Carousel, Text} from '#component/base';
import {LearningResourceCard} from '#component/partial/LearningResourceCard';
import {CarouselProvider} from '#component/provider';
import {useCarousel} from '#hook';
import {gridMarginVar, sprinkles} from '#style/sprinkles';

import {LearnMoreCarouselProps} from './LearnMoreCarousel.types';

import * as css from './LearnMoreCarousel.css';

const CarouselComponent = ({
  onCardClick,
  learningResources,
}: Pick<LearnMoreCarouselProps, 'learningResources' | 'onCardClick'>) => {
  const {ref} = useCarousel({slideWidth: 540, gap: 24});

  return (
    <Carousel
      className={css.carousel}
      ref={ref}
      widths={['100vw', '100vw', '100vw']}
      paddings={[gridMarginVar, gridMarginVar, gridMarginVar]}
      gap={24}>
      {learningResources.map(({id, imageUrl, title, type, duration}) => (
        <LearningResourceCard
          onClick={() => {
            onCardClick?.(`/learningresource/${id}`);
          }}
          key={id}
          imageUrl={imageUrl}
          type={type}
          headline={title}
          duration={duration}
          href={`/learningresource/${id}`}
        />
      ))}
    </Carousel>
  );
};

const CarouselControls = () => {
  const {goToNextSlide, goToPreviousSlide} = useCarousel();

  return (
    <div className={sprinkles({flex: ['none', 'flex'], content: 'between', gap: 10})}>
      <Button
        aria-label="Go to previous slide"
        icon="ArrowLeft"
        variant="secondary"
        onClick={goToPreviousSlide}
      />
      <Button
        aria-label="Go to next slide"
        icon="ArrowRight"
        variant="secondary"
        onClick={goToNextSlide}
      />
    </div>
  );
};

export const LearnMoreCarousel = ({
  className,
  learningResources,
  headerClassName,
  onCardClick,
}: LearnMoreCarouselProps) => (
  <div className={cx(sprinkles({layout: 'grid'}), className)}>
    <CarouselProvider>
      <div
        className={cx(
          sprinkles({
            colSpan: [4, 8, 12],
            content: 'between',
            flex: 'flex',
            items: 'center',
            pB: 32,
          }),
          headerClassName,
        )}>
        <Text variant="heading2" color="burgundy">
          Tally’s Take
        </Text>

        <CarouselControls />
      </div>

      <div className={sprinkles({colSpan: [4, 8, 12]})}>
        <CarouselComponent learningResources={learningResources} onCardClick={onCardClick} />
      </div>
    </CarouselProvider>
  </div>
);
